import { IStateType } from '../store';

export const getBase = (state: IStateType) => state.base;

export const getBaseField = <F extends keyof ReturnType<typeof getBase>> (field: F) => (state: IStateType) => getBase(state)[field];